import React, { FC } from 'react';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import { useVisibilityCheck } from '../../hooks/useVisibilityCheck';
import { useWidgetViewModel } from '../hooks/useWidgetViewModel';
import { Title } from './Title/Title';
import { ListFilter } from './ListFilter/ListFilter';
import { Breadcrumbs } from './Breadcrumbs/Breadcrumbs';
import { st, classes } from './Header.st.css';
import { DataHooks } from './consts';
import { HeaderViewModel } from '../../../../viewModel/headerViewModel/headerViewModel';
import { SERVICES_PAGES_BREADCRUMBS_EXPERIMENT } from '../../../../consts';

export interface HeaderProps {
  viewModel: HeaderViewModel;
}

export const Header: FC<HeaderProps> = ({ viewModel }) => {
  const { isMobile } = useEnvironment();
  const { shouldBeVisible } = useVisibilityCheck();
  const { experiments } = useExperiments();
  const { breadcrumbsViewModel } = useWidgetViewModel();
  const isTitleVisible = shouldBeVisible('isTitleVisible');
  const { isListFilterVisible } = viewModel;

  const isBreadcrumbsExperimentEnabled = experiments.enabled(
    SERVICES_PAGES_BREADCRUMBS_EXPERIMENT,
  );
  const isBreadcrumbsVisible =
    isBreadcrumbsExperimentEnabled && !!breadcrumbsViewModel;

  if (!isBreadcrumbsVisible && !isTitleVisible && !isListFilterVisible) {
    return null;
  }

  return (
    <div className={st(classes.root, { isMobile })} data-hook={DataHooks.ROOT}>
      {isBreadcrumbsVisible ? (
        <div className={classes.breadcrumbsWrapper}>
          <Breadcrumbs breadcrumbsViewModel={breadcrumbsViewModel!} />
        </div>
      ) : null}
      {isTitleVisible ? <Title /> : null}
      {isListFilterVisible ? <ListFilter /> : null}
    </div>
  );
};
